import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { User } from '../../types/user.model';
import { PROFESSIONAL_PROFILE_EDIT_MODE } from '../step-proffesional-profile/step-proffesional-profile.component';

@Component({
  selector: 'mmb-web-app-add-industry-modal',
  templateUrl: './add-industry-modal.component.html',
  styleUrls: ['./add-industry-modal.component.scss']
})
export class AddIndustryModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;
  @Input() editMode: PROFESSIONAL_PROFILE_EDIT_MODE;
  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      professionalTitle: [this.user.credentials ? this.user.credentials.professional_title : '', Validators.required],
      seniority: [this.user.credentials ? this.user.credentials.seniority_user : '', Validators.required],
      linkedInProfile: [this.user.linkedin ? this.user.linkedin.public_profile_url : ''],
      industryName: [this.user.credentials ? this.user.credentials.industry_secondary : '', Validators.required],
      yearsOfExperience: [this.user.credentials ? this.user.credentials.experience_years_user : '', [Validators.required, Validators.min(0), Validators.max(100)]],
      cv: [this.user.cvs && this.user.cvs.length > 0 ? this.user.cvs[0] : null],
    });
  }

  onClose() {
    this.closed.emit();
  }
}
